/* eslint-disable no-undef */
import { DisplayAdUnit } from './displayAdUnitContainer';

const props = [
    'slotId',
    'width',
    'height',
    'showOnPhone',
    'showOnTablet',
    'showOnDesktop',
    'isInfiniteScrollAd',
    'infiniteScrollIndex',
    'displayDefaultAd',
    'refreshAdEnabled'
];

export const DisplayAdUnitDirective = reactDirective => reactDirective(DisplayAdUnit, props);
DisplayAdUnitDirective.$inject = ['reactDirective'];

angular
    .module('WB.App')
    .directive('displayAdWidget', DisplayAdUnitDirective);
